import { Modal, Text } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers } from '../../../../../context/page-context';
import type { TeamInviteApiResponse } from '../../../types';
import { useDeleteTeamInvite } from '../../hooks/use-delete-team-invite';

export function DeleteInviteModal({
  invite,
  isOpen,
  closeModal,
}: {
  invite: TeamInviteApiResponse | null;
  isOpen: boolean;
  closeModal: () => void;
}) {
  const { notificationHandler } = useHandlers();
  const { mutate: deleteInvite, isPending, reset } = useDeleteTeamInvite();

  const handleClose = () => {
    if (isPending) {
      return;
    }
    reset();
    closeModal();
  };

  const handleSubmit = () => {
    if (!invite) {
      return;
    }

    deleteInvite(invite.id, {
      onSuccess: handleClose,
      onError: () => notificationHandler.error(),
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      primaryAction={{
        text: t('buttons:delete'),
        onClick: handleSubmit,
        danger: true,
        disabled: isPending,
        loading: isPending,
      }}
      secondaryAction={{
        text: t('buttons:cancel'),
        onClick: handleClose,
        disabled: isPending,
      }}
    >
      <Modal.Header>
        {t('features:account.components.modals.delete_invite_modal.header')}
      </Modal.Header>
      <Modal.Body>
        <Text>
          {t('features:account.components.modals.delete_invite_modal.body', {
            email: invite?.email ?? '',
          })}
        </Text>
      </Modal.Body>
    </Modal>
  );
}
